import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { useExpandableDropdown } from './expandable-dropdown';
import { cn } from '../../utils/cn';

interface ExpandableDropdownHeaderProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    asChild?: boolean;
}

export const ExpandableDropdownHeader = React.forwardRef<
    HTMLButtonElement,
    ExpandableDropdownHeaderProps
>(({ className, children, onClick, asChild = false, ...props }, ref) => {
    const { setOpen } = useExpandableDropdown();

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setOpen(false);
        onClick?.(e);
    };

    const Comp = asChild ? Slot : 'button';

    return (
        <Comp
            ref={ref}
            type={asChild ? undefined : 'button'}
            className={cn(
                'flex w-full shrink-0 items-center outline-none focus-visible:outline-none',
                className,
            )}
            onClick={handleClick}
            {...props}
        >
            {children}
        </Comp>
    );
});

ExpandableDropdownHeader.displayName = 'ExpandableDropdownHeader';
